import type { FC } from "react";

import styled from "styled-components";

import { Button, ButtonLabel, NotificationBar } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";

import type { INotificationItem } from "../../../../app/components/React/NotificationBarContainer/NotificationBarContainer";
import { BoldSpan } from "../../../pages/Leading Folders/src/LeadingFoldersInProgressInfoPanel";

interface IWorkspaceTrialNotificationBar extends INotificationItem {
    tryWorkspacesClick: () => {};
}

export const WorkspaceTrialInvitationNotificationBar: FC<IWorkspaceTrialNotificationBar> = (props) => {
    return (
        <NotificationBar onClose={props.onClose}>
            <div>
                <BoldSpan>
                    <I18n>workspace.invitation.trial.notification.bar.title.1</I18n>
                </BoldSpan>
                <MarginLeft>
                    <I18n>workspace.invitation.trial.notification.bar.title.2</I18n>
                </MarginLeft>
                <MarginSpan>
                    <Button
                        type="primary"
                        onClick={props.tryWorkspacesClick}
                    >
                        <ButtonLabel>
                            <I18n>workspace.invitation.trial.notification.bar.button</I18n>
                        </ButtonLabel>
                    </Button>
                </MarginSpan>
            </div>
        </NotificationBar>
    );
};

const MarginSpan = styled.span`
    margin: 0px 10px;
`;

export const MarginLeft = styled.span`
    margin-left: 5px;
`;
